import api from "./api";

export const loginUser = async (data) => {
  try {
    const res = await api.post("/login", data);
    return res.data;
  } catch (error) {
    throw error?.response?.data || { message: error.message };
  }
};

export const validateInvite = async (expires, user, signature) => {
  try {
    const res = await api.get(
      `/auth/magic-link/verify?expires=${expires}&user=${user}&signature=${signature}`
    );
    return res.data;
  } catch (error) {
    throw error?.response?.data || { message: error.message };
  }
};
